import { Space, Tag } from "antd"
import { WorkareaGroup } from "../../../../domain/workareas/group"
import { green, red } from "@ant-design/colors"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons"
import { hasValue } from "../../../../helpers/nullable"

type Props = {
  workareaGroup: WorkareaGroup
}

const approvedWhen = (approvedAt: string) => {
  if (!hasValue(approvedAt)) {
    return ''
  }

  const date = new Date(approvedAt)
  if (isNaN(date.valueOf())) {
    return ''
  }
  return ` on ${date.toLocaleDateString()}`
}

const ApprovedOrOnHoldDisplay = ({workareaGroup}: Props) => {
  if (workareaGroup.isOnHold) {
    return <Tag color={red.primary}>On Hold</Tag>
  }

  if (workareaGroup.isApproved) {
    const approvedByCustomer = !!workareaGroup.approvedByCustomerEmail || !!workareaGroup.approvedWithIpAddress
    return <Tag>
      <Space style={{color: approvedByCustomer ? green[6] : undefined}}>
        <FontAwesomeIcon icon={faCheckCircle} />
        <span>Approved {approvedByCustomer ? 'By Customer' : 'Internally'}{approvedWhen(workareaGroup.approvedAt)}</span>
      </Space>
    </Tag>
  }

  return null
}

export default ApprovedOrOnHoldDisplay